import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  flex: 1;
`;

export const Loading = styled.View``;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const EmptyContainer = styled.View`
  padding: 0 ${RFValue(20)}px;
  margin-top: -${RFValue(20)}px;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const EmptyEmoji = styled.Text`
  text-align: center;
  font-size: ${RFValue(22)}px;
  margin-bottom: 5px;
`;

export const Empty = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(14)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;
